// removed by extract-text-webpack-plugin
module.exports = {"paytoday":"duetodaycontainer-module__paytoday___2Vd56","paytodaytable":"duetodaycontainer-module__paytodaytable___3y4C5","price":"duetodaycontainer-module__price___3PLhe","totalprice":"duetodaycontainer-module__totalprice___z6bMK","total":"duetodaycontainer-module__total___2iS9T"};


//////////////////
// WEBPACK FOOTER
// ./src/components/duetodaycontainer.module.scss
// module id = 306
// module chunks = 1